import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  array,
} from 'libs/form';

export const MAX_FILES = 10;

export interface OnboardingSignatureSamplesFormType {
  fileIds: string[];
}

export const getSchema = (): ObjectSchema<OnboardingSignatureSamplesFormType> =>
  object({
    fileIds: array().of(string().required()).required().min(1).max(MAX_FILES),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<OnboardingSignatureSamplesFormType>();

export type FormErrors = FormErrorsBase<OnboardingSignatureSamplesFormType>;
